import React, { useContext, useState } from "react";
import Responsible from "./steps/Responsible";
import Passenger from "./steps/Passenger";
import SelectTrip from "./steps/SelectTrip";
import RegistrationFinished from "./steps/RegistrationFinished";
import { useNavigate, useParams } from "react-router-dom";
import {
  ValidateCI,
  ValidatePassport,
  ValidateDate,
  ValidateEmail,
  ValidatePhone,
} from "../shared/regex";
import secureLocalStorage from "react-secure-storage";
import useMobile from "../../hooks/useOrientation";
import { Passports } from "./steps/Passports";
import { warning } from "../../ui/colors";
import { SessionContext } from "../../helpers/session";
import { primary } from "../../ui/colors";

const primaryDark = "#00a896";
const primaryLight = "#e0faf7";

const STEPS = [
  { label: "Padre/Madre/Tutor" },
  { label: "Pasajero/a" },
  { label: "Viaje" },
  { label: "Confirmar" },
];

const RegisterScreen = () => {
  const { user } = useContext(SessionContext);
  const id = user?.id;
  let { userId } = useParams();

  const [step, setStep] = useState(id ? 2 : 1);
  const navigate = useNavigate();
  const isMobile = useMobile();
  const [userRegisteredId, setUserRegisteredId] = useState(
    secureLocalStorage.getItem("registeredUser"),
  );

  const [errorMessage, setErrorMessage] = useState();

  const [passengerData, setPassengerData] = useState({
    name: "",
    lastName: "",
    phone: "",
    birthDate: "",
    documentId: "",
    documentType: "CedulaIdentidad",
    email: "noesnecesario@gmail.com",
    highschool: "",
    address: "",
    department: "",
  });

  const [responsibleData, setResponsibleData] = useState({
    name: user?.name || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    phone: user?.phone || "",
  });

  const [tripData, setTripData] = useState({
    program: "",
    trip: "",
    group: "",
    programName: "",
    tripName: "",
    groupName: "",
  });

  const stringNotEmpty = (word) => !!word;

  const moveForward = () => {
    setErrorMessage("");
    if (step === 1) {
      const { name, lastName, email, phone } = responsibleData;
      if (
        stringNotEmpty(name) &&
        stringNotEmpty(lastName) &&
        stringNotEmpty(email) &&
        stringNotEmpty(phone)
      ) {
        if (!ValidateEmail(email)) {
          setErrorMessage("Email incorrecto.");
        } else {
          setStep(step + 1);
        }
      } else {
        setErrorMessage("Se deben completar todos los campos.");
      }
    } else if (step === 2) {
      const { name, lastName, phone, birthDate, documentId, documentType, highschool } =
        passengerData;
      const isPassport = documentType === "Pasaporte";
      if (
        stringNotEmpty(name) &&
        stringNotEmpty(lastName) &&
        stringNotEmpty(phone) &&
        stringNotEmpty(birthDate) &&
        stringNotEmpty(documentId) &&
        stringNotEmpty(highschool)
      ) {
        if (!ValidateDate(birthDate)) {
          setErrorMessage("Fecha de nacimiento incorrecta.");
        } else if (isPassport ? !ValidatePassport(documentId) : !ValidateCI(documentId)) {
          setErrorMessage(isPassport ? "Pasaporte incorrecto." : "Cédula incorrecta.");
        } else {
          setStep(step + 1);
        }
      } else {
        setErrorMessage("Se deben completar todos los campos.");
      }
    } else if (step === 3) {
      const { program, trip, group } = tripData;
      if (
        stringNotEmpty(program) &&
        stringNotEmpty(trip) &&
        stringNotEmpty(group)
      ) {
        setStep(step + 1);
      } else {
        setErrorMessage("Se deben completar todos los campos.");
      }
    } else {
      setStep(step + 1);
    }
  };

  const handleSetUserRegistered = (id) => {
    setUserRegisteredId(id);
    secureLocalStorage.setItem("registeredUser", id);
  };

  const getComponentStep = () => {
    switch (step) {
      case 1:
        return (
          <Responsible
            data={responsibleData}
            onChangeData={setResponsibleData}
          />
        );
      case 2:
        return (
          <Passenger data={passengerData} onChangeData={setPassengerData} />
        );
      case 3:
        return <SelectTrip data={tripData} onChangeData={setTripData} />;
      case 4:
        return (
          <RegistrationFinished
            responsibleData={responsibleData}
            passengerData={passengerData}
            tripData={tripData}
            onGoBack={() => setStep(1)}
            setUserRegisteredId={handleSetUserRegistered}
            userRegisteredId={userRegisteredId}
            associatedUserId={userId}
          />
        );
      default:
        return null;
    }
  };

  const isLastStep = step === 4;
  const isFirstStep = id ? step === 2 : step === 1;

  // Step index for indicator (0-based)
  const stepIndex = step - 1;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!isLastStep && (
        <div
          style={{
            ...styles.header,
            padding: isMobile ? "24px 16px 0" : "32px 0 0",
          }}
        >
          <h1 style={styles.title}>Registro</h1>

          {/* Step indicators */}
          <div style={styles.stepsRow}>
            {STEPS.map((s, i) => {
              const done = i < stepIndex;
              const current = i === stepIndex;
              return (
                <React.Fragment key={s.label}>
                  <div style={styles.stepItem}>
                    <div
                      style={{
                        ...styles.stepCircle,
                        background: done || current ? primary : "#e0e0e0",
                        color: done || current ? "#fff" : "#999",
                      }}
                    >
                      {done ? (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      ) : (
                        <span style={{ fontSize: 12, fontWeight: 700 }}>
                          {i + 1}
                        </span>
                      )}
                    </div>
                    {!isMobile && (
                      <span
                        style={{
                          ...styles.stepLabel,
                          color: current ? primaryDark : done ? "#aaa" : "#ccc",
                          fontWeight: current ? 700 : 400,
                        }}
                      >
                        {s.label}
                      </span>
                    )}
                  </div>
                  {i < STEPS.length - 1 && (
                    <div
                      style={{
                        ...styles.stepConnector,
                        background: done ? primary : "#e0e0e0",
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}

      {/* Step content */}
      <div
        style={{
          ...styles.contentWrapper,
          maxWidth: isLastStep ? 680 : 540,
          padding: isMobile ? "24px 16px" : "32px 24px",
        }}
      >
        {getComponentStep()}

        {/* Error */}
        {errorMessage && <div style={styles.errorBanner}>{errorMessage}</div>}

        {/* Navigation */}
        {!isLastStep && (
          <div style={styles.navRow}>
            {!isFirstStep && (
              <button
                style={styles.btnSecondary}
                onClick={() => setStep(step - 1)}
              >
                ← Anterior
              </button>
            )}
            <button
              style={{
                ...styles.btnPrimary,
                marginLeft: isFirstStep ? "auto" : 0,
              }}
              onClick={moveForward}
            >
              Siguiente →
            </button>
          </div>
        )}

        {/* Back to login/profile */}
        {!isLastStep && (
          <div style={{ textAlign: "center", marginTop: 12 }}>
            <button
              style={styles.linkBtn}
              onClick={() => navigate(user ? "/perfil" : "/login")}
            >
              {user ? "Ir al perfil" : "Volver al login"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisterScreen;

const styles = {
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 20,
    borderBottom: "1px solid #f0f0f0",
    paddingBottom: 24,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    color: "#111",
    fontFamily: "Gilroy-Bold",
    margin: 0,
  },
  stepsRow: {
    display: "flex",
    alignItems: "center",
    gap: 0,
  },
  stepItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
  },
  stepCircle: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s",
  },
  stepLabel: {
    fontSize: 12,
    whiteSpace: "nowrap",
  },
  stepConnector: {
    height: 2,
    width: 48,
    marginBottom: 18,
    transition: "background 0.2s",
  },
  contentWrapper: {
    width: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    flex: 1,
  },
  navRow: {
    display: "flex",
    gap: 12,
    marginTop: 24,
  },
  btnPrimary: {
    padding: "12px 28px",
    background: "#00D2B7",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: "Gilroy",
  },
  btnSecondary: {
    padding: "12px 28px",
    background: "transparent",
    border: "1.5px solid #e0e0e0",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    color: "#555",
    cursor: "pointer",
    fontFamily: "Gilroy",
  },
  linkBtn: {
    background: "none",
    border: "none",
    color: "#aaa",
    fontSize: 13,
    cursor: "pointer",
    textDecoration: "underline",
    fontFamily: "Gilroy",
  },
  errorBanner: {
    marginTop: 16,
    background: "#fdecea",
    border: "1px solid #f5c6c6",
    borderRadius: 8,
    padding: "10px 14px",
    color: "#c0392b",
    fontSize: 13,
  },
};
